import React from 'react';
import { useTranslation } from 'react-i18next';
import './TermsPage.css';

const TermsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="terms-page">
      <div className="terms-container">
        <h1>{t('termsOfService')}</h1>
        <div className="terms-content">
          <section>
            <h2>{t('termsIntroduction')}</h2>
            <p>{t('termsIntroductionText')}</p>
          </section>

          <section>
            <h2>{t('userAgreement')}</h2>
            <p>{t('userAgreementText')}</p>
          </section>

          <section>
            <h2>{t('serviceUsage')}</h2>
            <p>{t('serviceUsageText')}</p>
            <ul>
              <li>{t('usageRule1')}</li>
              <li>{t('usageRule2')}</li>
              <li>{t('usageRule3')}</li>
            </ul>
          </section>

          <section>
            <h2>{t('intellectualProperty')}</h2>
            <p>{t('intellectualPropertyText')}</p>
          </section>

          <section>
            <h2>{t('liability')}</h2>
            <p>{t('liabilityText')}</p>
          </section>

          <section>
            <h2>{t('termination')}</h2>
            <p>{t('terminationText')}</p>
          </section>

          <section>
            <h2>{t('changesToTerms')}</h2>
            <p>{t('changesToTermsText')}</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsPage; 